import { render } from "./DetallesEmpleado.vue?vue&type=template&id=efc7041e"
import script from "./DetallesEmpleado.vue?vue&type=script&lang=js"
export * from "./DetallesEmpleado.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__